import CustomerReceivablePaymentMdl from '@/models/POS/PosCustomerReceivablePayment'

export default async data => {
    try {
        //
        let response = await new CustomerReceivablePaymentMdl(data).save()
        return response
        //
    } catch (error) {
        return error.response.data
    }
}
